import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/concierge`;
export const TOKEN_KEY = "conciergeToken";

export const conciergeApi = axios.create({ baseURL: BASE });

conciergeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

conciergeApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !error.config.url.includes("/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/etoile";
    }
    return Promise.reject(error);
  }
);

export const errMsg = (error) => {
  const d = error.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg).join(" ");
  return "Une erreur est survenue";
};
